/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import { useTranslation } from "react-i18next";
import { payments } from "./payments.data";
import PaymentMethodCard from "./PaymentMethodCard";
import { COLORS } from "./payments.constants";

export default function PaymentMethodsSection() {
  const { i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  return (
    <section
      className="py-5"
      style={{
        background: COLORS.gradient,
        direction: isArabic ? "rtl" : "ltr",
        fontFamily: "'Tajawal', 'Cairo', sans-serif",
        color: COLORS.textLight,
      }}
    >
      <div className="container text-center">
        <h2
          className="fw-bold mb-4"
          style={{
            color: COLORS.gold,
            fontSize: "2.3rem",
            fontFamily: "'Cairo', sans-serif",
            letterSpacing: "0.5px",
          }}
        >
          {isArabic ? "طرق الدفع المتاحة" : "Available Payment Methods in Iraq"}
        </h2>

        <p
          style={{
            maxWidth: 750,
            margin: "0 auto",
            fontSize: "1.1rem",
            lineHeight: 1.8,
            opacity: 0.9,
          }}
        >
          {isArabic
            ? "منصة مدار تدعم أشهر طرق الدفع المحلية والعالمية في العراق لتسهيل عمليات الشراء والتحويل بأمان وسرعة."
            : "Madar supports the most popular local and international payment methods in Iraq for secure and fast transactions."}
        </p>

        <div className="row g-4 justify-content-center mt-5">
          {payments.map((p, i) => (
            <PaymentMethodCard key={i} payment={p} isArabic={isArabic} />
          ))}
        </div>

        <div
          style={{
            height: "3px",
            width: "90px",
            background: COLORS.gold,
            borderRadius: 5,
            margin: "50px auto 0",
            boxShadow: "0 0 10px rgba(242,180,65,0.4)",
          }}
        />
      </div>
    </section>
  );
}
